import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { title: "Títulos similares" },
  en: { title: "Similar titles" },
});
